module.exports = __webpack_public_path__ + "images/0463a5990c149071a2b7539ab8bb9289-IMG_4897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_4897.jpg
// module id = ./src/assets/images/slides/living2/IMG_4897.jpg
// module chunks = 0